import { useMemo, useCallback, useState, useEffect } from 'react'
import SensorsTrafficLight from './SensorsTrafficLight'
import OptionPresenter from '../../api/optionPresenter'

export default function NodesTrafficLight({ nodes = {} }) {

  const [statuses, setStatuses] = useState({ error: [], warning: [], working: [] })

  const getOptionStatusesValue = useCallback(() => {
    OptionPresenter.get('get-by-key/nodeStatuses')
      .then(data => {
        const fetchedValue = data?.value || {}
        setStatuses({
          error: fetchedValue.error || [],
          warning: fetchedValue.warning || [],
          working: fetchedValue.working || [],
        })
      })
      .catch(console.error)
  }, [])

  useEffect(() => {
    getOptionStatusesValue()
  }, [])

  const sensors = useMemo(() => {
    let good = 0
    let normal = 0
    let bad = 0

    Object.keys(nodes).forEach(status => {
      const count = nodes[status] || 0

      if (statuses.working.includes(status)) {
        good += count
      } else if (statuses.warning.includes(status)) {
        normal += count
      } else if (statuses.error.includes(status)) {
        bad += count
      }
    })

    return { good, normal, bad }
  }, [nodes, statuses])

  return <SensorsTrafficLight sensors={ sensors }/>
}
